import { ProductTranslationsSection } from "../ProductTranslationsSection";

/**
 * Paso 1 · SOLO contenido, en los dos idiomas.
 *
 * Tres campos —nombre, descripción y leyenda— por idioma, y nada más
 * (Anahí, 26-ago).
 *
 * ── Qué salió de aquí, y a dónde ────────────────────────────────────
 *  · El ESLOGAN se fue al paso de Beneficios. No se borró: la tienda lo
 *    pinta bajo el nombre y `contentFor` lo devuelve, así que quitarlo
 *    habría vaciado ese renglón en cada ficha que lo tiene escrito. Ver
 *    `ProductContentFields`.
 *
 *  · La DIRECCIÓN EN LA TIENDA (el slug) se fue al paso 2. Es la
 *    decisión menos obvia de las dos y merece el argumento entero:
 *
 *    Estaba aquí por un motivo bueno —se SUGIERE a partir del nombre en
 *    español mientras nadie lo toque, y verlo escribirse solo al lado
 *    del nombre del que sale explica el mecanismo sin una frase de
 *    ayuda—. Ese motivo sigue siendo cierto y aun así pierde, por dos
 *    razones.
 *
 *    La primera es que este paso ya no es "la información del producto"
 *    sino "el contenido en los dos idiomas", y el slug no tiene idioma:
 *    es UNO, sale del español y no se traduce. Puesto entre las
 *    pestañas de idioma, invita a creer que hay un slug por idioma.
 *
 *    La segunda es que el slug se elige UNA VEZ y no se cambia nunca, y
 *    eso lo emparenta con la categoría y el tipo —lo que el producto ES
 *    dentro del catálogo— mucho más que con lo que promete.
 *
 *    Lo que se pierde —ver la sugerencia mientras se teclea el nombre—
 *    se compensa donde importa: `SlugField` sigue derivándolo del nombre
 *    en español, así que al llegar al paso 2 ya está escrito, y su
 *    propia pista lo dice ("Se sugiere desde el nombre"). El mecanismo
 *    deja de verse y pasa a estar contado; a cambio, el paso 1 se lee
 *    entero de una vez.
 *
 * ── Y por qué el paso es UN solo bloque ─────────────────────────────
 * Con el slug fuera, aquí queda una sola tarjeta. La rejilla de bloques
 * que había —`FormSectionGrid` con dos— ya no tiene nada que repartir, y
 * un contenedor que envuelve un único hijo es un renglón de código que
 * solo puede confundir a quien lo lea después.
 */
export function InfoStep() {
  return <ProductTranslationsSection />;
}
